import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'sm:scrollbar-hidden overflow-x-auto'
  },
  variants: {
    color: {
      primary: 'text-black'
    }
  },
  defaultVariants: {
    color: 'primary'
  }
});
